import { Grid, GridItem } from '@rsa-digital/evo-shared-components/components/Grid';
import { graphql } from 'gatsby';
import React from 'react';

type CookiesListBlockProps = {
  cookies_list: {
    show_cookies_list: boolean;
  };
};

export const query = graphql`
  fragment CookiesListBlock on cs__cookies_list {
    show_cookies_list
  }
`;

const CookiesListBlock: React.FC<CookiesListBlockProps> = ({ cookies_list }) => {
  const { show_cookies_list } = cookies_list;

  return show_cookies_list ? (
    <Grid>
      <GridItem>
        <div id="ot-sdk-cookie-policy" data-cy="CookiesList" />
      </GridItem>
    </Grid>
  ) : null;
};

export default React.memo(CookiesListBlock);
